/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
// import { Dimensions } from 'react-native';
import { t } from 'i18next';

import { BsFillTelephoneFill } from "react-icons/bs";
import shareIcon from '../../images/share_icon.png'

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';


const HotelTable = () => {    
    return(
        <div className="sect-01-box-01-hotel">
            <div className='tbl-hotel-overview'>
                <table>
                    <colgroup>
                        <col width="17%"/>
                        <col width="35%"/>
                        <col width="10%"/>
                        {/* <col width="10%"/> */}
                        <col width="15%"/>
                        <col width="6%"/>
                        <col width="6%"/>
                        <col width="6%"/>
                    </colgroup>
                    <tbody>
                    <tr class='firstrow'>
                        <td class="firstrow first-child">{t("hotel_table_col1")}</td>
                        <td class="firstrow">{t("hotel_table_col2")}</td>
                        <td class="firstrow">{t("hotel_table_col3")}</td>
                        {/*<td class="firstrow">{t("hotel_table_col4")}</td>*/}
                        <td class="firstrow">{t("hotel_table_col5")}</td>
                        <td class="firstrow">{t("hotel_table_col6")}</td>
                        <td class="firstrow">{t("hotel_table_col7")}</td>
                        <td class="firstrow">{t("hotel_table_col8")}</td>
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name1")}</td>
                        <td rowSpan="2">{t("hotel_table_address1")}</td>
                        <td>{t("hotel_table_room1_1")}</td>
                        {/*<td>{t("hotel_table_price1_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco1")}</td>
                        <td rowSpan="2">{t("hotel_table_loc1")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='https://map.naver.com/v5/entry/place/1026782297?c=14375094.3107430,4238651.4691969,15,0,0,0,dh'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:052-264-2664'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("hotel_table_room1_2")}</td>
                        {/*<td>{t("hotel_table_price1_2")}</td>*/}
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name2")}</td>
                        <td rowSpan="2">{t("hotel_table_address2")}</td>
                        <td>{t("hotel_table_room2_1")}</td>
                        {/*<td>{t("hotel_table_price2_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco2")}</td>
                        <td rowSpan="2">{t("hotel_table_loc2")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='https://ktxmotel.modoo.at'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:052-254-1552'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("hotel_table_room2_2")}</td>
                        {/*<td>{t("hotel_table_price2_2")}</td>*/}
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name3")}</td>
                        <td rowSpan="2">{t("hotel_table_address3")}</td>
                        <td>{t("hotel_table_room3_1")}</td>
                        {/*<td>{t("hotel_table_price3_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco3")}</td>
                        <td rowSpan="2">{t("hotel_table_loc3")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='https://map.naver.com/v5/entry/place/1440993394?c=14375235.9647950,4238454.3830145,15,0,0,0,dh'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:0507-1498-8113'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("hotel_table_room3_2")}</td>
                        {/*<td>{t("hotel_table_price3_2")}</td>*/}
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name4")}</td>
                        <td rowSpan="2">{t("hotel_table_address4")}</td>
                        <td>{t("hotel_table_room4_1")}</td>
                        {/*<td>{t("hotel_table_price4_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco4")}</td>
                        <td rowSpan="2">{t("hotel_table_loc4")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='https://map.naver.com/v5/entry/place/38524816?c=14375235.9647950,4238454.3830145,15,0,0,0,dh'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:0507-1428-0092'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("hotel_table_room4_2")}</td>
                        {/*<td>{t("hotel_table_price4_2")}</td>*/}
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name5")}</td>
                        <td rowSpan="2">{t("hotel_table_address5")}</td>
                        <td>{t("hotel_table_room5_1")}</td>
                        {/*<td>{t("hotel_table_price5_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco5")}</td>
                        <td rowSpan="2">{t("hotel_table_loc5")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='http://blog.naver.com/iljpg'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:0507-1304-9683'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("hotel_table_room5_2")}</td>
                        {/*<td>{t("hotel_table_price5_2")}</td>*/}
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name6")}</td>
                        <td rowSpan="2">{t("hotel_table_address6")}</td>
                        <td rowSpan="2">{t("hotel_table_room6_1")}</td>
                        {/*<td>{t("hotel_table_price6_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco6")}</td>
                        <td rowSpan="2">{t("hotel_table_loc6")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='https://map.naver.com/v5/entry/place/1032599016?c=14395112.9281682,4239326.0766456,15,0,0,0,dh'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:052-956-0100'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        {/*<td>{t("hotel_table_price6_2")}</td>*/}
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name7")}</td>
                        <td rowSpan="2">{t("hotel_table_address7")}</td>
                        <td rowSpan="2">{t("hotel_table_room7_1")}</td>
                        {/*<td>{t("hotel_table_price7_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco7")}</td>
                        <td rowSpan="2">{t("hotel_table_loc7")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='http://www.shillastay.com/ulsan'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:052-901-9000'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        {/*<td>{t("hotel_table_price7_2")}</td>*/}
                    </tr>
                    <tr>
                        <td>{t("hotel_table_name8")}</td>
                        <td>{t("hotel_table_address8")}</td>
                        <td>{t("hotel_table_room8_1")}</td>
                        {/*<td>{t("hotel_table_price8_1")}</td>*/}
                        <td>{t("hotel_table_ueco8")}</td>
                        <td>{t("hotel_table_loc8")}</td>
                        <td class="hotel-overview-link">
                            <a href='http://www.ulsancityhotel.co.kr/'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td>
                            <a href='tel:052-240-2000'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("hotel_table_name9")}</td>
                        <td>{t("hotel_table_address9")}</td>
                        <td>{t("hotel_table_room9_1")}</td>
                        {/*<td>{t("hotel_table_price9_1")}</td>*/}
                        <td>{t("hotel_table_ueco9")}</td>
                        <td>{t("hotel_table_loc9")}</td>
                        <td class="hotel-overview-link">
                            <a href='https://www.lottehotel.com/ulsan-city/ko.html'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td>
                            <a href='tel:052-990-1000'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name10")}</td>
                        <td rowSpan="2">{t("hotel_table_address10")}</td>
                        <td rowSpan="2">{t("hotel_table_room10_1")}</td>
                        {/*<td>{t("hotel_table_price10_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco10")}</td>
                        <td rowSpan="2">{t("hotel_table_loc10")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='https://www.lottehotel.com/ulsan-hotel/ko.html'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:052-960-1000'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        {/*<td>{t("hotel_table_price10_2")}</td>*/}
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name11")}</td>
                        <td rowSpan="2">{t("hotel_table_address11")}</td>
                        <td rowSpan="2">{t("hotel_table_room11_1")}</td>
                        {/*<td>{t("hotel_table_price11_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco11")}</td>
                        <td rowSpan="2">{t("hotel_table_loc11")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='http://www.stazhotelulsan.com'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:052-922-4000'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        {/*<td>{t("hotel_table_price11_2")}</td>*/}
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name12")}</td>
                        <td rowSpan="2">{t("hotel_table_address12")}</td>
                        <td>{t("hotel_table_room12_1")}</td>
                        {/*<td>{t("hotel_table_price12_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco12")}</td>
                        <td rowSpan="2">{t("hotel_table_loc12")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='https://map.naver.com/v5/entry/place/1730969619?c=14397986.1510172,4237639.2322183,15,0,0,0,dh'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:052-276-3993'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("hotel_table_room12_2")}</td>
                        {/*<td>{t("hotel_table_price12_2")}</td>*/}
                    </tr>
                    <tr>
                        <td rowSpan="2">{t("hotel_table_name13")}</td>
                        <td rowSpan="2">{t("hotel_table_address13")}</td>
                        <td>{t("hotel_table_room13_1")}</td>
                        {/*<td>{t("hotel_table_price13_1")}</td>*/}
                        <td rowSpan="2">{t("hotel_table_ueco13")}</td>
                        <td rowSpan="2">{t("hotel_table_loc13")}</td>
                        <td rowSpan="2" class="hotel-overview-link">
                            <a href='http://www.hhotelkorea.com'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td rowSpan="2">
                            <a href='tel:0507-1404-9044'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("hotel_table_room13_2")}</td>
                        {/*<td>{t("hotel_table_price13_2")}</td>*/}
                    </tr>
                    <tr>
                        <td>{t("hotel_table_name14")}</td>
                        <td>{t("hotel_table_address14")}</td>
                        <td>{t("hotel_table_room14_1")}</td>
                        {/*<td>{t("hotel_table_price14_1")}</td>*/}
                        <td>{t("hotel_table_ueco14")}</td>
                        <td>{t("hotel_table_loc14")}</td>
                        <td class="hotel-overview-link">
                            <a href='https://www.instagram.com/toyokoinn_ulsan'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td>
                            <a href='tel:052-257-1045'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("hotel_table_name15")}</td>
                        <td>{t("hotel_table_address15")}</td>
                        <td>{t("hotel_table_room15_1")}</td>
                        {/*<td>{t("hotel_table_price15_1")}</td>*/}
                        <td>{t("hotel_table_ueco15")}</td>
                        <td>{t("hotel_table_loc15")}</td>
                        <td class="hotel-overview-link">
                            <a href='https://www.lahanhotels.com/ulsan/index.do'>
                                <img src={shareIcon}/>
                            </a>
                        </td>
                        <td>
                            <a href='tel:052-251-2233'>
                                <BsFillTelephoneFill size="20px" style={{display:"inline-block"}}/>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default HotelTable;